import {SelectedBranchStates} from '../../States';

const INITIAL_STATE = localStorage.getItem('selectedBranch')
    ? JSON.parse(localStorage.getItem('selectedBranch'))
    : '';

export const SelectedBranchReducer = (
    state = INITIAL_STATE,
    action,
) => {
    const {type, payload} = action;

    switch (type) {
    case SelectedBranchStates.SUCCESS:
        return {...payload, reducer_status: SelectedBranchStates.SUCCESS};

    case SelectedBranchStates.FAILED:
        return {...payload, reducer_status: SelectedBranchStates.FAILED};

    case SelectedBranchStates.RESET:
        return INITIAL_STATE;

    default:
        return state;
    }
};
